import { Controller } from '@hotwired/stimulus';

class ActivityIframe extends Controller {
  connect() {
    window.addEventListener('message', (event) => {
      this.receiveMessage(event);
    });
  }

  disconnect() {
    window.removeEventListener('message', this.receiveMessage);
  }

  receiveMessage(event) {
    // Ignore events that come from windows we do not trust
    var prodOrigin = /^(http|https)?:?\/\/assets.culturalcompetency.ca/;
    var devOrigin = /^(http|https)?:?\/\/(localhost|127.0.0.1|(app|admin).local.sanyas.ca):/;
    if (!(event.origin.match(prodOrigin) || event.origin.match(devOrigin))) {
      return;
    }

    // Ignore React DevTools messages
    if (event.data && event.data.source === "react-devtools-content-script") {
      return;
    }

    // Parse event data, which may be a string or an object
    const { message } = (typeof event.data === "string") ? JSON.parse(event.data) : event.data;
    const pathname = message?.src?.pathname;

    // We can add additional data handling or DOM manipulation here

    // Resize when the iframe src matches the message src
    // Expected format: { message: { type: "resize", src: { pathname: "/path", ... }, boundingRect: { height: 123, ... } } }
    // `boundingRect` is standardized from `contentRect` (ResizeObserver) or `getBoundingClientRect()`
    // `src` is the iframe's `document.location`, use slice(0, -1) to ignore trailing slash
    if (message?.type === "resize" && pathname && this.element.src.includes(pathname.slice(0, -1)) && message?.boundingRect) {
      this.element.height = message.boundingRect.height;
    }
  }
}

export default ActivityIframe;
